// extracted by css-extract-rspack-plugin
export default {"closeButtonWrapper":"DonationForm_closeButtonWrapper__4hryB","closeButton":"DonationForm_closeButton__6IFmw","container":"DonationForm_container__ITP9j"};